import { useToastContext } from '../context/ToastContext';

export default function useToast() {
  const { push, dismiss } = useToastContext();
  return {
    success: (message: string, durationMs?: number) => push('success', message, durationMs),
    error: (message: string, durationMs?: number) => push('error', message, durationMs),
    info: (message: string, durationMs?: number) => push('info', message, durationMs),
    dismiss,
  };
}
